const ADS_ID = "AW-16491492865";
const ENQUIRY_DESTINATION = "AW-16491492865/BlrJCPS0pK4dEIHs4Lc9";
let configured = false;
const reportedEnquiries = new Set();

function canTrack() {
  return typeof window !== "undefined" &&
    ["www.hotsnail.com.au", "hotsnail.com.au"].indexOf(window.location.hostname) !== -1 &&
    window.location.pathname.indexOf("/document-scanning/") === 0 &&
    typeof window.gtag === "function";
}

export function initialiseScanningAds() {
  if (!canTrack()) return false;
  try {
    if (!configured) {
      window.gtag("config", ADS_ID, { send_page_view: false });
      configured = true;
    }
    return true;
  } catch (error) {
    // Analytics must never turn a successful enquiry into a form error.
    return false;
  }
}

export function createScanningEnquiryId() {
  if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
    const bytes = new Uint32Array(4);
    window.crypto.getRandomValues(bytes);
    return "scan-" + Array.from(bytes).map(n => n.toString(16)).join("-");
  }
  return "scan-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
}

export function recordScanningEnquiry(enquiryId) {
  if (!enquiryId || reportedEnquiries.has(enquiryId) || !initialiseScanningAds()) return false;
  try {
    window.gtag("event", "conversion", {
      send_to: ENQUIRY_DESTINATION,
      transaction_id: enquiryId,
    });
    reportedEnquiries.add(enquiryId);
    return true;
  } catch (error) {
    return false;
  }
}
